export default "__VITE_ASSET__167eadc1__"